import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { initializeApp } from "firebase/app";
import BaseUrl from "./BaseUrl";
import ApiSuffix from "./ApiSuffix";

const firebaseConfig = {
  apiKey: "AIzaSyAwJYcNS3ABu9XTDyIAESpVjLf4wz3fSPA",
  authDomain: "workx-b6820.firebaseapp.com",
  projectId: "workx-b6820",
  storageBucket: "workx-b6820.firebasestorage.app",
  messagingSenderId: "902574018778",
  appId: "1:902574018778:web:0ec0cbd43a7c913b46d5e3",
  measurementId: "G-1NCMNCQ0FW",
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);
const vapidKey = "BCx66Kppn2rjaSWO0Q8DnkmCbsMrz7FJZePTzh3aTcelTWHlozrq7f1RQgK_FG_oaIbdIt5KjfMx615YfX5-YLw";

class NotificationService {
  constructor() {
    this.messaging = messaging;
    this.isSupported = this.checkSupport();
  }

  checkSupport() {
    return "serviceWorker" in navigator && "PushManager" in window;
  }

  isTokenSentToServer(token) {
    const sentToken = localStorage.getItem("fcm_token_sent");
    return sentToken === token;
  }

  markTokenAsSent(token) {
    localStorage.setItem("fcm_token_sent", token);
  }

  async requestPermission() {
    if (!this.isSupported) {
      console.warn("This browser does not support notifications");
      return false;
    }

    try {
      const permission = await Notification.requestPermission();
      console.log("Notification permission:", permission);

      if (permission === "granted") {
        return true;
      } else if (permission === "denied") {
        console.warn("Notification permission denied");
        return false;
      } else {
        console.warn("Notification permission dismissed");
        return false;
      }
    } catch (error) {
      console.error("Error requesting notification permission:", error);
      return false;
    }
  }

  async getToken() {
    if (!this.isSupported) {
      console.warn("FCM not supported");
      return null;
    }

    try {
      await this.registerServiceWorker();

      const currentToken = await getToken(this.messaging, { vapidKey });

      if (currentToken) {
        console.log("FCM Token:", currentToken);
        const previousToken = localStorage.getItem("fcm_token");
        localStorage.setItem("fcm_token", currentToken);

        if (!this.isTokenSentToServer(currentToken) || previousToken !== currentToken) {
          await this.sendTokenToServer(currentToken);
        } else {
          console.log("FCM token already sent to server, skipping...");
        }

        return currentToken;
      } else {
        console.log("No registration token available.");
        return null;
      }
    } catch (error) {
      console.error("An error occurred while retrieving token:", error);
      return null;
    }
  }

  async registerServiceWorker() {
    if ("serviceWorker" in navigator) {
      try {
        await navigator.serviceWorker.register("/firebase-messaging-sw.js");
        console.log("Service Worker registered successfully");
      } catch (error) {
        console.error("Service Worker registration failed:", error);
      }
    }
  }

  async sendTokenToServer(token) {
    try {
      const authToken = localStorage.getItem("token");
      const username = localStorage.getItem("username");

      if (!authToken || !username) {
        console.warn("User not authenticated, cannot send FCM token");
        return;
      }

      //    const apiUrl = window.location.origin.includes('localhost') ? 'http://localhost:8000' : window.location.origin;

      if (window.location.hostname === "localhost") return;

      const apiUrl = BaseUrl.dev + ApiSuffix.submitFCMToken;

      const device_type = navigator.userAgent.match(/\(([^)]+)\)/)[1];

      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: authToken,
        },
        body: JSON.stringify({
          fcm_token: token,
          device_type: device_type,
        }),
      });

      if (response.ok) {
        const res = await response.json();
        if (res.error === false) {
          console.log("FCM token sent to server successfully");
          this.markTokenAsSent(token);
        } else {
          console.error("Failed to send FCM token to server:", res.error_msg);
        }
      } else {
        console.error("Failed to send FCM token to server");
      }
    } catch (error) {
      console.error("Error sending FCM token to server:", error);
    }
  }

  setupForegroundListener() {
    onMessage(this.messaging, (payload) => {
      console.log("Message received in foreground:", payload);

      this.showCustomNotification(payload);
    });
  }

  showCustomNotification(payload) {
    const { title, body } = payload.notification || {};
    const { data } = payload;

    const notificationContainer = this.createNotificationElement(title, body, data);
    document.body.appendChild(notificationContainer);

    if (!payload.isTest) {
      setTimeout(() => {
        if (notificationContainer && notificationContainer.parentNode) {
          notificationContainer.parentNode.removeChild(notificationContainer);
        }
      }, 5000);
    }
  }

  showTestNotification() {
    console.log("showTestNotification called");

    const testPayload = {
      notification: {
        title: "Test Notification",
        body: "This is a permanent test notification for UI development. You can style and improve this notification.",
      },
      data: {
        url: "#",
      },
      isTest: true,
    };

    try {
      this.showCustomNotification(testPayload);
      console.log("Permanent test notification displayed for UI development");
    } catch (error) {
      console.error("Error showing test notification:", error);
    }
  }

  removeAllNotifications() {
    const notifications = document.querySelectorAll(".fcm-notification");
    notifications.forEach((notification) => {
      if (notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    });
    console.log("All notifications removed");
  }

  createNotificationElement(title, body, data) {
    console.log("Creating notification element:", title, body);

    const notification = document.createElement("div");
    notification.className = "fcm-notification";
    notification.innerHTML = `
   <a href="/tasks" class="fcm-notification-content">
    <div class="fcm-notification-icon">
     <img src="/workx-192.png" alt="Notification" />
    </div>
    <div class="fcm-notification-text">
     <h4>${title || "Notification"}</h4>
     <p>${body || ""}</p>
    </div>
    <button class="fcm-notification-close">&times;</button>
   </a>
  `;

    const closeBtn = notification.querySelector(".fcm-notification-close");
    closeBtn.addEventListener("click", () => {
      if (notification && notification.parentNode) {
        notification.parentNode.removeChild(notification);
      }
    });

    const content = notification.querySelector(".fcm-notification-content");
    content.addEventListener("click", (e) => {
      if (e.target !== closeBtn) {
        if (data && data.url) {
          window.location.href = data.url;
        }
        if (notification && notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }
    });

    return notification;
  }

  async initialize() {
    if (!this.isSupported) {
      console.warn("Notifications not supported in this browser");
      return false;
    }

    const hasPermission = await this.requestPermission();

    if (!hasPermission) {
      return false;
    }
    await this.getToken();

    this.setupForegroundListener();

    return true;
  }

  hasPermission() {
    return Notification.permission === "granted";
  }

  clearSentTokenMarker() {
    localStorage.removeItem("fcm_token_sent");
    console.log("FCM token sent marker cleared - will resend on next initialization");
  }

  async removeToken() {
    try {
      const token = localStorage.getItem("fcm_token");
      if (token) {
        // Send removal request to server
        const authToken = localStorage.getItem("token");
        if (authToken) {
          const apiUrl = window.location.origin.includes("localhost") ? "http://localhost:8000" : window.location.origin;

          await fetch(BaseUrl.dev + ApiSuffix.deleteFCMToken + "?fcm_token=" + token, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: authToken,
            },
            body: JSON.stringify({ token }),
          });
        }

        // Clear both token and sent marker
        localStorage.removeItem("fcm_token");
        localStorage.removeItem("fcm_token_sent");
        console.log("FCM token removed");
      }
    } catch (error) {
      console.error("Error removing FCM token:", error);
    }
  }
}

export default new NotificationService();

// Popup the notifiction with dummy content for UI imporovement
